const SSO_CONSTANTS = {
  SSO_PROVIDERS: {
    NONE:0,
    PING_FRED:1,
    AZURE:2
},
 CLIENT_AUTH_TYPE :{
    NONE : 0,
    CLIENT_SECRET: 1,
    PRIVATE_KEY_JWT: 2,
    TLS: 3,
}

}
const validates = (validURL, t) => {
  return (values) => {
    const errors = {};
    if (!values.webClientId) {
      errors.webClientId = t("validation.rules.sso.rule1"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.CLIENT_ID});
    } else if (values.webClientId.length > 256) {
      errors.webClientId = t("validation.rules.sso.rule3"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.CLIENT_ID,var2:50});
    }

    if (values.ssoProvider ===  SSO_CONSTANTS.SSO_PROVIDERS.AZURE) {
      if (!values.clientSecret && !(parseInt(values.clientAuthType) ===  SSO_CONSTANTS.CLIENT_AUTH_TYPE.TLS)) {
        errors.clientSecret = t("validation.rules.sso.rule55"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.CLIENT_ID});
      } else if (values.webClientId.length > 256) {
        errors.clientSecret = t("validation.rules.sso.rule56"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.CLIENT_ID,var2:50});
      }
    }
    
    if (!values.webRedirectURI) {
      errors.webRedirectURI = t("validation.rules.sso.rule4"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.WEB_REDIRECT_URI});
    } else if (
      !(
        validURL.isHttpsUri(values.webRedirectURI) ||
        validURL.isHttpUri(values.webRedirectURI)
      )
    ) {
      errors.webRedirectURI = t("validation.rules.sso.rule7"); //sc(SSO_CONSTANTS.VALID_INPUT,{var1:SSO_CONSTANTS.LABLE.WEB_REDIRECT_URI});
    } else if (values.webRedirectURI.length > 255) {
      errors.webRedirectURI = t("validation.rules.sso.rule5"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.WEB_REDIRECT_URI,var2:255});
    }

    if (!values.authorizationURL) {
      errors.authorizationURL = t("validation.rules.sso.rule19"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.AUTHORIZATION_ENDPOINT_URL});
    } else if (
      !(
        validURL.isHttpsUri(values.authorizationURL) ||
        validURL.isHttpUri(values.authorizationURL)
      )
    ) {
      errors.authorizationURL = t("validation.rules.sso.rule17"); //sc(SSO_CONSTANTS.VALID_INPUT,{var1:SSO_CONSTANTS.LABLE.AUTHORIZATION_ENDPOINT_URL});
    } else if (values.authorizationURL.length > 255) {
      errors.authorizationURL = t("validation.rules.sso.rule20"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.AUTHORIZATION_ENDPOINT_URL,var2:255});
    }

    if (!values.tokenURL) {
      errors.tokenURL = t("validation.rules.sso.rule21"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.TOKEN_ENDPOINT_URL});
    } else if (
      !(
        validURL.isHttpsUri(values.tokenURL) ||
        validURL.isHttpUri(values.tokenURL)
      )
    ) {
      errors.tokenURL = t("validation.rules.sso.rule37"); //sc(SSO_CONSTANTS.VALID_INPUT,{var1:SSO_CONSTANTS.LABLE.TOKEN_ENDPOINT_URL});
    } else if (values.tokenURL.length > 255) {
      errors.tokenURL = t("validation.rules.sso.rule22"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.TOKEN_ENDPOINT_URL,var2:255});
    }
    if (values.ssoProvider != SSO_CONSTANTS.SSO_PROVIDERS.AZURE) {
      if (!values.userInfoURL) {
        errors.userInfoURL = t("validation.rules.sso.rule23"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.USERINFO_ENDPOINT_URL});
      } else if (
        !(
          validURL.isHttpsUri(values.userInfoURL) ||
          validURL.isHttpUri(values.userInfoURL)
        )
      ) {
        errors.userInfoURL = t("validation.rules.sso.rule38"); //sc(SSO_CONSTANTS.VALID_INPUT,{var1:SSO_CONSTANTS.LABLE.USERINFO_ENDPOINT_URL});
      } else if (values.userInfoURL.length > 255) {
        errors.userInfoURL = t("validation.rules.sso.rule24"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.USERINFO_ENDPOINT_URL,var2:255});
      }
    }
    

    if (values.ssoProvider != SSO_CONSTANTS.SSO_PROVIDERS.AZURE) {
      if (!values.introspectionURL) {
        errors.introspectionURL = t("validation.rules.sso.rule25"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.INTROSPECTION_URL});
      } else if (
        !(
          validURL.isHttpsUri(values.introspectionURL) ||
          validURL.isHttpUri(values.introspectionURL)
        )
      ) {
        errors.introspectionURL = t("validation.rules.sso.rule39"); //sc(SSO_CONSTANTS.VALID_INPUT,{var1:SSO_CONSTANTS.LABLE.INTROSPECTION_URL});
      } else if (values.introspectionURL.length > 255) {
        errors.introspectionURL = t("validation.rules.sso.rule26"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.INTROSPECTION_URL,var2:255});
      }
    }

    if (values.ssoProvider != SSO_CONSTANTS.SSO_PROVIDERS.AZURE) {
      if (!values.revokeURL) {
        errors.revokeURL = t("validation.rules.sso.rule27"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.REVOKE_ENDPOINT_URL});
      } else if (
        !(
          validURL.isHttpsUri(values.revokeURL) ||
          validURL.isHttpUri(values.revokeURL)
        )
      ) {
        errors.revokeURL = t("validation.rules.sso.rule40"); //sc(SSO_CONSTANTS.VALID_INPUT,{var1:SSO_CONSTANTS.LABLE.REVOKE_ENDPOINT_URL});
      } else if (values.revokeURL.length > 255) {
        errors.revokeURL = t("validation.rules.sso.rule28"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.REVOKE_ENDPOINT_URL,var2:255});
      }
    }

     
      if (!values.logoutURL) {
        errors.logoutURL = t("validation.rules.sso.rule29"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.LOGOUT_ENDPOINT_URL});
      } else if (
        !(
          validURL.isHttpsUri(values.logoutURL) ||
          !validURL.isHttpUri(values.logoutURL)
        )
      ) {
        errors.logoutURL = t("validation.rules.sso.rule41"); //sc(SSO_CONSTANTS.VALID_INPUT,{var1:SSO_CONSTANTS.LABLE.LOGOUT_ENDPOINT_URL});
      } else if (values.logoutURL.length > 255) {
        errors.logoutURL = t("validation.rules.sso.rule30"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.LOGOUT_ENDPOINT_URL,var2:255});
      }


    // if (values.ssoParameterMappingEnable && !values.roleParam) {
    //   errors.roleParam = t('validation.rules.sso.rule31')//sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.ROLE_PARAM});
    // }else if (values.roleParam.length > 50) {
    //   errors.roleParam = t('validation.rules.sso.rule32')//sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.ROLE_PARAM,var2:50});
    // }

    if (values.ssoParameterMappingEnable && !values.adminRoleParam) {
      errors.adminRoleParam = t("validation.rules.sso.rule51"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.ROLE_PARAM});
    } else if (values.adminRoleParam && values.adminRoleParam.length > 50) {
      errors.adminRoleParam = t("validation.rules.sso.rule52"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.ROLE_PARAM,var2:50});
    }

    if (values.ssoParameterMappingEnable && !values.managerRoleParam) {
      errors.managerRoleParam = t("validation.rules.sso.rule53"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.ROLE_PARAM});
    } else if (values.managerRoleParam.length > 50) {
      errors.managerRoleParam = t("validation.rules.sso.rule54"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.ROLE_PARAM,var2:50});
    }

    if (values.ssoParameterMappingEnable && !values.siteNameParam) {
      errors.siteNameParam = t("validation.rules.sso.rule47"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.ROLE_PARAM});
    } else if (values.siteNameParam.length > 50) {
      errors.siteNameParam = t("validation.rules.sso.rule48"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.ROLE_PARAM,var2:50});
    }

    if (
      values.ssoParameterMappingEnable &&
      (!values.adminRoles || values.adminRoles.length == 0)
    ) {
      errors.adminRoles = t("validation.rules.sso.rule43");
    } else if (
      values.ssoParameterMappingEnable &&
      values.adminRoles.length > 0
    ) {
      values.adminRoles.forEach((element) => {
        if (element.length > 255) {
          errors.adminRoles = t("validation.rules.sso.rule50");
          return;
        }
      });
    }

    if (
      values.ssoParameterMappingEnable &&
      (!values.managerRoles || values.managerRoles.length == 0)
    ) {
      errors.managerRoles = t("validation.rules.sso.rule44");
    } else if (
      values.ssoParameterMappingEnable &&
      values.managerRoles.length > 0
    ) {
      values.managerRoles.forEach((element) => {
        if (element.length > 255) {
          errors.managerRoles = t("validation.rules.sso.rule50");
          return;
        }
      });
    }

    if (!values.userNameParam) {
      errors.userNameParam = t("validation.rules.sso.rule33"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.USER_NAME_PARAM});
    } else if (values.userNameParam.length > 50) {
      errors.userNameParam = t("validation.rules.sso.rule34"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.USER_NAME_PARAM,var2:50});
    }

    if (!values.authorizationScope) {
      errors.authorizationScope = t("validation.rules.sso.rule35"); //sc(SSO_CONSTANTS.REQUIRED,{var1:SSO_CONSTANTS.LABLE.AUTHORIZATION_SCOPE});
    } else if (values.authorizationScope.length > 100) {
      errors.authorizationScope = t("validation.rules.sso.rule36"); //sc(SSO_CONSTANTS.INVALID_INPUT_LENGTH,{var1:SSO_CONSTANTS.LABLE.AUTHORIZATION_SCOPE,var2:50});
    }

    return errors;
  };
};

module.exports = {
  validates,
};
